import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook } from "lucide-react";
// Using public folder logo
const logo = "/logoBgRemoved.png";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="bg-white p-2 rounded">
                <img
                  src={logo}
                  alt="Sandhurst Interiors Logo"
                  className="h-32 w-auto"
                />
              </div>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Family-run commercial interior specialists with over 30 years'
              experience in workspace refurbishment, fit-out and maintenance
              across the South East.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/sandhurstinteriors/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary-400 transition-colors duration-200"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/projects"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Projects
                </Link>
              </li>
              <li>
                <Link
                  to="/testimonials"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Testimonials
                </Link>
              </li>
              <li>
                <Link
                  to="/socials"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Socials
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* SEO / Service pages */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/office-fit-out-south-east"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Office Fit-Out South East
                </Link>
              </li>
              <li>
                <Link
                  to="/office-refurbishment"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Office Refurbishment
                </Link>
              </li>
              <li>
                <Link
                  to="/office-partitioning"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Office Partitioning
                </Link>
              </li>
              <li>
                <Link
                  to="/commercial-fit-out"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Commercial Fit-Out
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Phone className="w-4 h-4 text-primary-400" />
                <a
                  href="tel:07775614165"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  07775614165
                </a>
                <Phone className="w-4 h-4 text-primary-400" />
                <a
                  href="tel:01256769343"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  01256769343
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-4 h-4 text-primary-400 flex-shrink-0" />
                <a
                  href="mailto:dominicbrown@sandhurstinteriors.co.uk"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  dominicbrown@sandhurstinteriors.co.uk
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin className="w-4 h-4 text-primary-400" />
                <span className="text-gray-300">Hampshire, SE England</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            © {new Date().getFullYear()} Sandhurst Interiors. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
